import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AccountService } from '../_services/account.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalLoginComponent } from '../home/modal-login/modal-login.component';

@Injectable({ providedIn: 'root' })

export class AuthGuardAdmin implements CanActivate {
    constructor(
        private router: Router,
        private accountService: AccountService,
        private modalService: NgbModal
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const user = this.accountService.userValue;
        if (user != null && user.rol===1) {
            return true;
        }
        // not logged in so redirect to login page with the return url
        //this.router.navigate(['/account/login'], { queryParams: { returnUrl: state.url }});
        this.router.navigate(['home']);
        this.openLogin();
        return false;

    }
    openLogin() {
      const modalRef = this.modalService.open(ModalLoginComponent, {
        centered: true,
        backdrop:'static'
      });
    }
}
